<template>
  <div>
    <el-dialog
        title="Xuất file tổng hợp điểm danh"
        :visible.sync="dialogVisible"
        width="550px"
        :before-close="closeDialog"
        :close-on-click-modal="false"
        custom-class="sk-dialog"
        top="8vh"
    >
      <div class="sk-dialog-content">
        <div class="sk-panel" style="margin-bottom: 20px;">
          <div class="sk-panel-head">
            <div class="sk-panel-icon"><i class="el-icon-download"></i></div>
            <div>
              <p class="sk-panel-title">Tùy chọn xuất dữ liệu</p>
              <p class="sk-panel-subtitle">
                Vui lòng cấu hình khoảng thời gian, loại đối tượng và trạng thái mong muốn để xuất file báo cáo dữ liệu.
              </p>
            </div>
          </div>
        </div>

        <el-form
            label-width="120px"
            :model="dataInput"
            label-position="left"
            ref="dataInput"
            class="export-form"
        >
          <el-form-item label="Chọn ngày:">
            <el-date-picker
                v-model="dateStartEnd"
                type="daterange"
                unlink-panels
                style="width: 100%"
                start-placeholder="Ngày bắt đầu"
                end-placeholder="Ngày kết thúc"
                value-format="yyyy-MM-dd"
                format="dd-MM-yyyy"
            ></el-date-picker>
          </el-form-item>

          <el-form-item label="Chọn kiểu:">
            <el-radio-group v-model="dataInput.type" @change="handleChangeType">
              <el-radio v-if="command !== 'by-month'" label="school">Toàn trường</el-radio>
              <el-radio label="class">Theo lớp</el-radio>
              <el-radio label="group">Theo nhóm</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item v-if="dataInput.type === 'class'" label="Chọn lớp:">
            <el-select v-model="dataInput.classId" clearable placeholder="Chọn lớp" style="width: 100%">
              <el-option
                  v-for="item in classListCommon"
                  :key="item.id"
                  :label="item.className"
                  :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item v-if="dataInput.type === 'group'" label="Chọn nhóm:">
            <el-select v-model="dataInput.groupId" clearable placeholder="Chọn nhóm" style="width: 100%">
              <el-option
                  v-for="item in groupList"
                  :key="item.id"
                  :label="item.nameGroup"
                  :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Trạng thái:" prop="status">
            <el-select
                clearable
                style="width: 100%"
                v-model="dataInput.status"
                placeholder="Tất cả trạng thái"
            >
              <el-option
                  v-for="item in kidStatusList"
                  :key="item.key"
                  :value="item.key"
                  :label="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="sk-dialog-footer">
        <el-button
            class="btn-cancel"
            type="danger"
            size="medium"
            @click="closeDialog()"
        >
          <i class="el-icon-circle-close"/>
          <span>{{ $t("button.close") }}</span>
        </el-button>

        <el-button
            class="btn-save"
            :disabled="!isDisabledExportExcel"
            type="success"
            size="medium"
            :loading="loadingButton"
            @click="submitForm()"
        >
          <i class="el-icon-circle-check"/>
          <span>Xuất file Excel</span>
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {kidStatusList} from "@/constant/listCommon";
import revenueManagementService from "@/services/Finance_Kids_V2/RevenueManagementService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import AttendanceV3Service from "@/attendance_v3/services/AttendanceV3Service";

export default {
  name: "AttendanceOptionsExportExcel",
  props: {
    dialogVisible: null,
    type: {type: String, default: null},
    typeExport: {type: String, default: null},
  },

  data() {
    return {
      kidStatusList,
      dateStartEnd: [],
      dataInput: {
        type: this.type,
        classId: null,
        groupId: null,
        status: null,
      },
      loadingButton: false,
      groupList: [],
      command: this.typeExport,
    };
  },
  watch: {
    type(v) {
      this.dataInput.type = v;
    },

    typeExport(v) {
      this.command = v;
    }
  },
  computed: {
    ...mapGetters('classStore', ['classListCommon']),
    isDisabledExportExcel() {
      if (this.dateStartEnd && this.dateStartEnd.length !== 0) {
        if (this.dataInput.type === "class") {
          return this.dataInput.classId !== null && this.dataInput.classId !== '';
        } else if (this.dataInput.type === "group") {
          return this.dataInput.groupId !== null && this.dataInput.groupId !== '';
        }

        return true;
      }
      return false;
    }
  },
  async created() {
    this.$store.dispatch('classStore/fetchDataClassListCommon');
    await this.getAllGroup();
  },
  methods: {
    getAllGroup() {
      return AttendanceV3Service.getListKidsGroup().then((res) => {
        this.groupList = res.data
        if (this.groupList.length > 0) {
          this.localGroup = this.groupList[0].id
        }
      }).catch(() => {
        NotifyMessage.leftCornerNotificationError("Lỗi dữ liệu!")
      })
    },
    closeDialog() {
      this.dateStartEnd = [];
      this.dataInput.status = null;
      this.dataInput.classId = null;
      this.dataInput.groupId = null;
      this.$emit("close");
    },
    submitForm() {
      this.$emit("export-excel", {
        rangeDate: this.dateStartEnd,
        type: this.dataInput.type,
        classId: this.dataInput.classId,
        groupId: this.dataInput.groupId,
        status: this.dataInput.status,
      });
    },
    handleChangeType() {
      if (this.dataInput.type === "class") {
        this.dataInput.groupId = null;
      } else if (this.dataInput.type === "group") {
        this.dataInput.classId = null;
      } else {
        this.dataInput.groupId = null;
        this.dataInput.classId = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/sk-dialog.scss";

/deep/ .sk-dialog {
  .el-dialog__header {
    background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  }

  .el-dialog__title {
    color: #fff;
  }
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  color: white !important;
  font-size: 24px;
}

.export-form {
  padding: 0 10px;

  /* Đồng bộ lại chiều cao dòng và bo tròn tương thích hệ thống */
  /deep/ .el-form-item {
    margin-bottom: 18px;

    .el-form-item__label {
      font-weight: 500;
      color: #4b5563;
    }

    .el-input__inner {
      border-radius: 8px;
    }

    .el-range-editor.el-input__inner {
      border-radius: 8px;
    }
  }
}
</style>